import { Component, OnDestroy, OnInit } from '../../../../../core/decorators';

@Component({
    selector: 'filter-table',
    bindings: {
        filter: '=',
        model: '='
    },
    template: require('./filter-table.tpl.html')
})
export class FilterTableComponent implements OnInit, OnDestroy {
    model: any;
    constructor() {}

    ngOnInit(): void {}

    ngOnDestroy(): void {}
}
